import React, { useState } from 'react';
import axios from 'axios';
import { Row, Col, Input, Modal, ModalBody, ModalHeader, Card, CardBody, CardFooter, Label } from 'reactstrap';
import { FaCog } from 'react-icons/fa'
import CustomToast from '../../../utils/CustomToast';

import DownloadIcon from "assets/img/bis/download-icon.png";

const CollaboratorLogos = ({ name, onSave, isError, currentUser, token }) => {
    const hiddenFileInputLogo = React.useRef(null);

    const [filename, setFilename] = useState('');
    const [fileURL, setFileURL] = useState('');

    const [uploadModalShow, setUploadModalShow] = useState(false);
    const [uploadedFileError, setUploadedFileError] = useState(false);
    const [uploadedFileLoading, setUploadedFileLoading] = useState(false);

    const uploadFiles = (e) => {
        e.preventDefault();
        setUploadModalShow(true);
    }

    const preventDefault = (e) => {
        e.preventDefault();
    }

    const handleClickPdf = () => {
        hiddenFileInputLogo.current.click();
    };

    const handleDragEnter = e => {
        e.preventDefault();
    };

    const handleDragOver = e => {
        e.preventDefault();
    };

    const handleDragLeave = e => {
        e.preventDefault();
    };

    const handleDrop = e => {
        e.preventDefault();

        const droppedFiles = e.dataTransfer.files;
        const totalFilesCount = droppedFiles.length;

        if (totalFilesCount > 1) {
            const message = "This field accepts only 1 image!";
            CustomToast.warning(message);
            setUploadedFileError(true);
            hiddenFileInputLogo.current.value = null;
            return;
        }

        if (uploadedFileLoading)
            return;

        setUploadedFileLoading(true);

        if (droppedFiles[0]) {
            const file = droppedFiles[0];
            setFilename(file.name);
            logoValidations(file);
        }
    };

    const handleChangeFiles = e => {
        e.preventDefault();

        const droppedFiles = e.target.files;
        const totalFilesCount = droppedFiles.length;

        if (totalFilesCount > 1) {
            const message = "This field accepts only 1 image!";
            CustomToast.warning(message);
            setUploadedFileError(true);
            hiddenFileInputLogo.current.value = null;
            return;
        }

        if (uploadedFileLoading)
            return;

        setUploadedFileLoading(true);

        if (droppedFiles[0]) {
            const file = droppedFiles[0];
            logoValidations(file);
        }

    }

    const submitLogo = (logo) => {
        const dataArray = new FormData();
        dataArray.append("file", logo);
        axios.post(process.env.REACT_APP_API_ENDPOINT + 'upload/collaborator/logo?user_id=' + currentUser + '&token=' + token, dataArray)
            .then((response) => {
                if (response.data.status == "Success") {
                    const result = response.data.data;
                    setFileURL(result.file);
                    setFilename(logo.name);
                    hiddenFileInputLogo.current.value = null;
                    setUploadedFileLoading(false);
                } else {
                    setUploadedFileError(true);
                    setUploadedFileLoading(false);
                    hiddenFileInputLogo.current.value = null;
                    CustomToast.defaultWarning();
                }
            })
            .catch(() => {
                hiddenFileInputLogo.current.value = null;
                setUploadedFileLoading(false);
                setUploadedFileError(true);
                CustomToast.defaultError();
            });
    };

    const logoValidations = (file) => {
        if (file.type.includes('image')) {

            setUploadedFileError(false);
            submitLogo(file);
        } else {
            CustomToast.warning('Logo must be image!');
            hiddenFileInputLogo.current.value = null;
            setUploadedFileLoading(false);
            setUploadedFileError(true);
        }
    }

    const handleCloseUpload = () => {
        setUploadedFileError(false);
        setUploadModalShow(false);
        setFilename('');
        setFileURL('');
    }

    const handleUpload = () => {
        onSave({ name: filename, url: fileURL });
        setFilename('');
        setFileURL('');
        handleCloseUpload();
    }

    return (
        <>
            <Row>
                <Col lg='9 pr-0' className="mb-0">
                    <Input
                        type="text"
                        className={
                            isError
                                ? 'form-invalid'
                                : ''
                        }
                        value={name ? name : 'No Uploaded Logo'}
                        disabled
                    />
                </Col>
                <Col lg='3' className="mb-0">
                    <button
                        className="action-btn btn newbtntheme primary-btn no-shadow w-100"
                        onClick={(e) => uploadFiles(e)}>
                        <FaCog /> UPLOAD
                    </button>
                </Col>
            </Row>

            <Modal
                isOpen={uploadModalShow}
                className="modal-preview"
                fade={false}
                centered
                id="edit-judge-modal"
            >
                <ModalHeader className="text-left">
                    UPLOAD LOGO
                    {!uploadedFileLoading && (
                        <button type="button" className="close react-modal-close" data-dismiss="modal" aria-label="Close" onClick={handleCloseUpload}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    )}
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody className="card_container">
                                    <Label
                                        onClick={handleClickPdf}
                                        onDragEnter={handleDragEnter}
                                        onDragOver={handleDragOver}
                                        onDragLeave={handleDragLeave}
                                        onDrop={handleDrop}
                                        className={uploadedFileError ? "download_icon form-invalid" : "download_icon"}
                                        style={uploadedFileLoading ? { cursor: 'not-allowed', opacity: '0.5' } : {}}
                                    >
                                        <img
                                            src={DownloadIcon}
                                        />
                                        <br />
                                        {filename ? filename : name ? name : 'Upload logo here'}
                                    </Label>
                                    {uploadedFileError ?
                                        <p role="alert" className="invalid-feedback">Logo is required</p>
                                        :
                                        null
                                    }
                                    <input type="file"
                                        ref={hiddenFileInputLogo}
                                        accept={'image/*'}
                                        onChange={handleChangeFiles}
                                        style={{ display: 'none' }}
                                        required
                                        disabled={uploadedFileLoading}
                                    />
                                </CardBody>
                                <CardFooter className="text-right">
                                    {!uploadedFileLoading && (
                                        <button type="button" className="btn btn-main btn-main-alt mr-2" data-dismiss="modal" onClick={handleCloseUpload}>CLOSE</button>
                                    )}
                                    {!uploadedFileLoading ?
                                        <button type="button" className="newbuttontheme w-25" onClick={handleUpload}>SAVE</button>
                                        :
                                        <button type="button" className="newbuttontheme w-25" onClick={preventDefault}>UPLOADING...</button>
                                    }
                                </CardFooter>
                            </Card>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </>
    );
}

export default CollaboratorLogos;